import { createCommand, LexicalCommand } from "lexical";

/**
 * Custom command for clearing formatting
 */
export const CLEAR_FORMATTING_COMMAND: LexicalCommand<void> = createCommand(
  "CLEAR_FORMATTING_COMMAND"
);
